module.exports = __webpack_public_path__ + "cc7d43c8f6c80ff48b535b6fd8952578.svg";